import {Box, CircularProgress, Stack, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import {BASE_URL, getFeaturedLoadouts} from "../../api/API";
import {Link} from "react-router-dom";
import UserLoadout from "../../components/loadout/UserLoadout";

const GoToLoadoutButton = ({loadoutId}) => {
    return (
        <Link target="_blank" to={`${BASE_URL}loadouts/${loadoutId}`}
              style={{textDecoration: 'none'}}>
            <Stack direction='row'
                   sx={{
                       m: '0 5px',
                       height: '60%',
                       p: '5px 8px',
                       color: 'text.primary',
                       borderRadius: '5px',
                       backgroundColor: 'rgba(0,0,0,0.4)',
                       alignItems: 'center',
                       justifyContent: 'center',
                       transition: 'background-color 0.3s ease',
                       '&:hover': {backgroundColor: 'rgba(255,255,255,0.1)'}
                   }}>
                <Typography>Full Stats</Typography>
            </Stack>
        </Link>
    )
}
const Loadouts = ({loadouts}) => {
    if ((loadouts?.loadouts ?? []).length === 0) {
        return <Typography variant='h4'
                           sx={{
                               pb: '15px',
                               pl: {xs: 0, md: '10px'},
                               width: {xs: '100%', md: '80%'},
                               textAlign: 'center',
                               mt: {xs: '10px', md: '20px'},
                               fontStyle: 'oblique',
                               fontSize: {xs: '1.2rem', md: '1.5rem'},
                           }}>
            No featured loadouts yet. ):
        </Typography>
    }
    return [
        <Typography variant='h4'
                    sx={{
                        pl: {xs: 0, md: '10px'},
                        width: {xs: '100%', md: '80%'},
                        textAlign: {xs: 'center', md: 'left'},
                        position: 'sticky',
                        mt: {xs: '10px', md: '20px'},
                        fontStyle: 'oblique',
                        fontSize: {xs: '1.6rem', md: '2rem'},
                    }}>
            Featured Loadouts
        </Typography>,
        <Stack width={{xs: '100%', md: '80%'}} minWidth={{xs: null, md: '900px'}}>
            {loadouts.loadouts.map((loadout) => <UserLoadout loadoutId={loadout.id} user ={loadout.user} showUserChip/>)}
        </Stack>
    ];
}

const FeaturedLoadouts = ({weapon}) => {
    const [loadouts, setLoadouts] = useState("loading")

    useEffect(() => {
        if (weapon == null) return
        getFeaturedLoadouts(weapon)
            .then((response) => response.json()
                    .then((response) => {
                        setLoadouts(response)
                    }),
                (response) => {
                    setLoadouts([])
                    // setLoadouts({
                    //     description: "[desc]",
                    //     loadouts: [
                    //         {
                    //             id: "QUNSJG0zLGIyLGY3LG80LGcz",
                    //             user: {
                    //                 name: "XDLoadout",
                    //                 socials: {twitter: "XDLoadout"}
                    //             }
                    //         }
                    //     ]
                    // })
                })
    }, [weapon])

    if (loadouts === "loading") return <CircularProgress/>

    return (
        <Stack alignItems='center' width='100%'>
            <Box sx={{
                p: '5px',
                m: {xs: 0, md: '5px 10px'},
                maxWidth: '90%',
                borderRadius: '3px',
                backgroundColor: 'rgba(0,0,0,0.2)'
            }}>
                <Typography textAlign='center' fontStyle='oblique'
                            fontSize={{xs: '0.8rem', md: '1rem'}}>
                    {loadouts.description}
                </Typography>
            </Box>
            <Loadouts loadouts={loadouts}/>
        </Stack>
    )
}
export default FeaturedLoadouts